import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './career-search-component.component.scss';
import axios from 'axios';
import * as $ from 'jquery';
var CareerSearchComponent = /** @class */ (function (_super) {
    tslib_1.__extends(CareerSearchComponent, _super);
    function CareerSearchComponent(element) {
        return _super.call(this, element) || this;
    }
    CareerSearchComponent.prototype.init = function () {
        var _this = this;
        // containers
        if (this.element.querySelector('.career-search-component__content--showing')) {
            this.containerShowing = this.element.querySelector('.career-search-component__content--showing');
        }
        if (this.element.querySelector('.career-search-component__content--loader')) {
            this.containerLoader = this.element.querySelector('.career-search-component__content--loader');
        }
        if (this.element.querySelector('.career-search-component__content--empty')) {
            this.containerEmpty = this.element.querySelector('.career-search-component__content--empty');
        }
        if (this.element.querySelector('.career-search-component__content--items')) {
            this.containerItems = this.element.querySelector('.career-search-component__content--items');
        }
        if (this.element.querySelector('.career-search-component__content--pagination')) {
            this.containerPagination = this.element.querySelector('.career-search-component__content--pagination');
        }
        // varaibles
        if (this.element.querySelector('.js-var-showing')) {
            this.jsShowing = this.element.querySelector('.js-var-showing');
        }
        if (this.element.querySelector('.js-var-reset')) {
            this.jsResetButton = Array.from(this.element.querySelectorAll('.js-var-reset'));
        }
        if (this.element.getAttribute('data-detail-url')) {
            this.attributeDetailPage = this.element.getAttribute('data-detail-url');
        }
        // button
        if (this.element.querySelector('.filter-builder__form-field--searchbutton')) {
            this.buttonSearch = this.element.querySelector('.filter-builder__form-field--searchbutton');
        }
        if (this.element.querySelector('.filter-builder__form-field--searchbuttonclear')) {
            this.buttonSearchClear = this.element.querySelector('.filter-builder__form-field--searchbuttonclear');
        }
        if (this.element.querySelector('.pagination__nav--prev')) {
            this.buttonPaginationPrevious = this.element.querySelector('.pagination__nav--prev');
        }
        if (this.element.querySelector('.pagination__nav--next')) {
            this.buttonPaginationNext = this.element.querySelector('.pagination__nav--next');
        }
        // filters
        if (this.element.querySelector('.js-var-filter-form')) {
            this.filterForm = this.element.querySelector('.js-var-filter-form');
        }
        if (this.element.querySelector('.js-form-search-bar')) {
            this.filterInput = this.element.querySelector('.js-form-search-bar');
        }
        if (this.element.querySelector('.js-var-filter-country')) {
            this.filterCountry = this.element.querySelector('.js-var-filter-country');
        }
        if (this.element.querySelector('.js-var-filter-region')) {
            this.filterRegion = this.element.querySelector('.js-var-filter-region');
        }
        if (this.element.querySelector('.js-var-filter-city')) {
            this.filterCity = this.element.querySelector('.js-var-filter-city');
        }
        if (this.element.querySelector('.js-var-filter-language')) {
            this.filterLanguage = Array.from(this.element.querySelectorAll('.js-var-filter-language'));
        }
        if (this.element.querySelector('.js-var-filter-language-select')) {
            this.filterLanguageSelect = Array.from(this.element.querySelectorAll('.js-var-filter-language-select'));
        }
        if (this.element.querySelector('.js-var-filter-locationtype')) {
            this.filterWorkArrangement = Array.from(this.element.querySelectorAll('.js-var-filter-locationtype'));
        }
        // filters mobile
        if (this.element.querySelector('.js-var-filter-mobile-country')) {
            this.filterMobileCountry = this.element.querySelector('.js-var-filter-mobile-country');
        }
        if (this.element.querySelector('.js-var-filter-mobile-region')) {
            this.filterMobileRegion = this.element.querySelector('.js-var-filter-mobile-region');
        }
        if (this.element.querySelector('.js-var-filter-mobile-city')) {
            this.filterMobileCity = this.element.querySelector('.js-var-filter-mobile-city');
        }
        if (this.element.querySelector('.js-var-filter-mobile-language')) {
            this.filterMobileLanguage = Array.from(this.element.querySelectorAll('.js-var-filter-mobile-language'));
        }
        if (this.element.querySelector('.js-var-filter-mobile-language-select')) {
            this.filterMobileLanguageSelect = Array.from(this.element.querySelectorAll('.js-var-filter-mobile-language-select'));
        }
        if (this.element.querySelector('.js-var-filter-mobile-locationtype')) {
            this.filterMobileWorkArrangement = Array.from(this.element.querySelectorAll('.js-var-filter-mobile-locationtype'));
        }
        if (this.element.querySelector('.js-var-filter-mobile-reset-filters')) {
            this.filterMobileButtonResetFilter = this.element.querySelector('.js-var-filter-mobile-reset-filters');
        }
        if (this.element.querySelector('.js-var-filter-mobile-apply')) {
            this.filterMobileButtonApply = this.element.querySelector('.js-var-filter-mobile-apply');
        }
        // init
        this.varUrl = "https://api.smartrecruiters.com/v1/companies/StandardBankGroup/postings";
        this.varLimit = 20;
        this.varOffset = 0;
        this.varDestination = 'PUBLIC';
        this.varLanguage = '';
        this.varLocationType = 'ANY';
        this.varQuery = '';
        this.varPaginationIndex = 0;
        this.varSelectedIndexCountry = 0;
        this.varSelectedIndexRegion = 0;
        this.varSelectedIndexCity = 0;
        // locations
        this.locations = [];
        // pagination items
        $(document).on('click', 'li.pagination__item', function (e) {
            var target = e.target;
            var page = target.getAttribute('data-page');
            var limit = target.getAttribute('data-limit');
            var offset = parseInt(page) * parseInt(limit);
            _this.varPaginationIndex = parseInt(page);
            _this.varLimit = limit;
            _this.varOffset = offset;
            _this.filterFunction();
            $('html,body').animate({
                scrollTop: $('.career-search-component__content').offset().top - 20
            }, 'slow');
        });
        // form submit
        $('form.js-var-filter-form').submit(function (e) {
            e.preventDefault();
            _this.varOffset = 0;
            _this.varPaginationIndex = 0;
            _this.filterFunction();
            $('html,body').animate({
                scrollTop: $('.career-search-component__content').offset().top - 20
            }, 'slow');
        });
        // onload
        this.onload();
    };
    CareerSearchComponent.prototype.bindEvents = function () {
        var _this = this;
        //////////////////////////////////////////
        //////////////////////////////////////////
        // DESKTOP
        //////////////////////////////////////////
        //////////////////////////////////////////
        if (this.filterInput) {
            this.filterInput.addEventListener('keyup', function (event) {
                var element;
                if (event.currentTarget) {
                    element = event.currentTarget;
                }
                else {
                    element = event.target;
                }
                var parent = element.closest('.filter-builder__form-field--container');
                var clearButton = parent.querySelector('.filter-builder__form-field--searchbuttonclear');
                var searchButton = parent.querySelector('.filter-builder__form-field--searchbutton');
                if (element.value.length > 0) {
                    clearButton.classList.remove('d-none');
                    searchButton.classList.add('active');
                }
                else {
                    clearButton.classList.add('d-none');
                    searchButton.classList.remove('active');
                }
                _this.varQuery = element.value;
            });
        }
        if (this.filterCountry) {
            this.filterCountry.addEventListener('change', function (event) {
                // resets
                _this.varOffset = 0;
                _this.varPaginationIndex = 0;
                _this.varSelectedIndexCountry = _this.filterCountry.selectedIndex;
                // update
                _this.varCountry = event.target.value;
                _this.varRegion = '';
                _this.varCity = '';
                if (_this.varCountry) {
                    var items = _this.locations[_this.varSelectedIndexCountry - 1].regions;
                    _this.generateOption(_this.filterRegion, items, 'normal', 'name', 'name', 'All Regions');
                    _this.filterRegion.removeAttribute('disabled');
                    _this.generateOption(_this.filterCity, [], 'normal', 'name', 'name', 'All Cities');
                    _this.filterCity.setAttribute('disabled', 'disabled');
                }
                else {
                    _this.generateOption(_this.filterRegion, [], 'normal', 'name', 'name', 'All Regions');
                    _this.generateOption(_this.filterCity, [], 'normal', 'name', 'name', 'All Cities');
                    _this.filterRegion.setAttribute('disabled', 'disabled');
                    _this.filterCity.setAttribute('disabled', 'disabled');
                }
                _this.filterFunction();
            });
        }
        if (this.filterRegion) {
            this.filterRegion.addEventListener('change', function (event) {
                // resets
                _this.varOffset = 0;
                _this.varPaginationIndex = 0;
                _this.varSelectedIndexRegion = _this.filterRegion.selectedIndex;
                // update
                _this.varRegion = event.target.value;
                _this.varCity = '';
                if (_this.varRegion) {
                    var items = _this.locations[_this.varSelectedIndexCountry - 1].regions[_this.varSelectedIndexRegion - 1].cities;
                    _this.generateOption(_this.filterCity, items, 'normal', 'name', 'name', 'All Cities');
                    _this.filterCity.removeAttribute('disabled');
                }
                else {
                    _this.generateOption(_this.filterCity, [], 'normal', 'name', 'name', 'All Cities');
                    _this.filterCity.setAttribute('disabled', 'disabled');
                }
                _this.filterFunction();
            });
        }
        if (this.filterCity) {
            this.filterCity.addEventListener('change', function (event) {
                // resets
                _this.varOffset = 0;
                _this.varPaginationIndex = 0;
                // update
                _this.varCity = event.target.value;
                _this.filterFunction();
            });
        }
        if (this.filterLanguage) {
            this.filterLanguage.map(function (filter) { return filter.addEventListener('click', function (event) {
                // resets
                _this.varOffset = 0;
                _this.varPaginationIndex = 0;
                // update
                _this.varLanguage = event.target.value;
                _this.filterFunction();
            }); });
        }
        if (this.filterLanguageSelect) {
            this.filterLanguageSelect.map(function (filter) { return filter.addEventListener('change', function (event) {
                // resets
                _this.varOffset = 0;
                _this.varPaginationIndex = 0;
                // update
                _this.varLanguage = event.target.value;
                _this.filterFunction();
            }); });
        }
        if (this.filterWorkArrangement) {
            this.filterWorkArrangement.map(function (filter) { return filter.addEventListener('click', function (event) {
                // resets
                _this.varOffset = 0;
                _this.varPaginationIndex = 0;
                // update
                var locationTypes = [];
                _this.filterWorkArrangement.forEach(function (element) {
                    if (element.checked) {
                        locationTypes.push(element.value);
                    }
                });
                if (locationTypes.length === 2) {
                    _this.varLocationType = 'ANY';
                }
                else if (locationTypes.length === 1) {
                    _this.varLocationType = locationTypes[0];
                }
                else {
                    _this.varLocationType = 'ANY';
                }
                _this.filterFunction();
            }); });
        }
        if (this.jsResetButton) {
            this.jsResetButton.map(function (filter) { return filter.addEventListener('click', function (event) {
                // resets
                _this.varLimit = 10;
                _this.varOffset = 0;
                _this.varDestination = 'PUBLIC';
                _this.varLanguage = '';
                _this.varLocationType = 'ANY';
                _this.varQuery = '';
                _this.varPaginationIndex = 0;
                _this.varCountry = '';
                _this.varRegion = '';
                _this.varCity = '';
                _this.varSelectedIndexCountry = 0;
                _this.varSelectedIndexRegion = 0;
                _this.varSelectedIndexCity = 0;
                _this.generateOption(_this.filterRegion, [], 'normal', 'name', 'name', 'All Regions');
                _this.generateOption(_this.filterCity, [], 'normal', 'name', 'name', 'All Cities');
                _this.filterRegion.setAttribute('disabled', 'disabled');
                _this.filterCity.setAttribute('disabled', 'disabled');
                _this.filterForm.reset();
                _this.filterFunction();
            }); });
        }
        //////////////////////////////////////////
        //////////////////////////////////////////
        // MOBILE
        //////////////////////////////////////////
        //////////////////////////////////////////
        if (this.filterMobileCountry) {
            this.filterMobileCountry.addEventListener('change', function (event) {
                _this.varSelectedIndexCountry = _this.filterMobileCountry.selectedIndex;
                // update
                _this.varCountry = event.target.value;
                _this.varRegion = '';
                _this.varCity = '';
                if (_this.varCountry) {
                    var items = _this.locations[_this.varSelectedIndexCountry - 1].regions;
                    _this.generateOption(_this.filterMobileRegion, items, 'normal', 'name', 'name', 'All Regions');
                    _this.filterMobileRegion.removeAttribute('disabled');
                }
                else {
                    _this.generateOption(_this.filterMobileRegion, [], 'normal', 'name', 'name', 'All Regions');
                    _this.generateOption(_this.filterMobileCity, [], 'normal', 'name', 'name', 'All Cities');
                    _this.filterMobileRegion.setAttribute('disabled', 'disabled');
                    _this.filterMobileCity.setAttribute('disabled', 'disabled');
                }
            });
        }
        if (this.filterMobileRegion) {
            this.filterMobileRegion.addEventListener('change', function (event) {
                // resets
                _this.varSelectedIndexRegion = _this.filterMobileRegion.selectedIndex;
                // update
                _this.varRegion = event.target.value;
                _this.varCity = '';
                if (_this.varRegion) {
                    var items = _this.locations[_this.varSelectedIndexCountry - 1].regions[_this.varSelectedIndexRegion - 1].cities;
                    _this.generateOption(_this.filterMobileCity, items, 'normal', 'name', 'name', 'All Cities');
                    _this.filterMobileCity.removeAttribute('disabled');
                }
                else {
                    _this.generateOption(_this.filterMobileCity, [], 'normal', 'name', 'name', 'All Cities');
                    _this.filterMobileCity.setAttribute('disabled', 'disabled');
                }
            });
        }
        if (this.filterMobileCity) {
            this.filterMobileCity.addEventListener('change', function (event) {
                // update
                _this.varCity = event.target.value;
            });
        }
        if (this.filterMobileLanguage) {
            this.filterMobileLanguage.map(function (filter) { return filter.addEventListener('click', function (event) {
                // update
                _this.varLanguage = event.target.value;
            }); });
        }
        if (this.filterMobileLanguageSelect) {
            this.filterMobileLanguageSelect.map(function (filter) { return filter.addEventListener('change', function (event) {
                // update
                _this.varLanguage = event.target.value;
            }); });
        }
        if (this.filterMobileWorkArrangement) {
            this.filterMobileWorkArrangement.map(function (filter) { return filter.addEventListener('click', function (event) {
                // update
                var locationTypes = [];
                _this.filterWorkArrangement.forEach(function (element) {
                    if (element.checked) {
                        locationTypes.push(element.value);
                    }
                });
                if (locationTypes.length === 2) {
                    _this.varLocationType = 'ANY';
                }
                else if (locationTypes.length === 1) {
                    _this.varLocationType = locationTypes[0];
                }
                else {
                    _this.varLocationType = 'ANY';
                }
            }); });
        }
        if (this.filterMobileButtonResetFilter) {
            this.filterMobileButtonResetFilter.addEventListener('click', function (event) {
                // resets
                _this.varLimit = 10;
                _this.varOffset = 0;
                _this.varDestination = 'PUBLIC';
                _this.varLanguage = '';
                _this.varLocationType = 'ANY';
                _this.varQuery = '';
                _this.varPaginationIndex = 0;
                _this.varCountry = '';
                _this.varRegion = '';
                _this.varCity = '';
                _this.varSelectedIndexCountry = 0;
                _this.varSelectedIndexRegion = 0;
                _this.varSelectedIndexCity = 0;
                _this.generateOption(_this.filterRegion, [], 'normal', 'name', 'name', 'All Regions');
                _this.generateOption(_this.filterCity, [], 'normal', 'name', 'name', 'All Cities');
                _this.filterRegion.setAttribute('disabled', 'disabled');
                _this.filterCity.setAttribute('disabled', 'disabled');
                _this.filterForm.reset();
            });
        }
        if (this.filterMobileButtonApply) {
            this.filterMobileButtonApply.addEventListener('click', function (event) {
                // run function
                $('div.js-rich-text-modal-modal-close').click();
                _this.filterFunction();
            });
        }
        //////////////////////////////////////////
        //////////////////////////////////////////
        // button search
        //////////////////////////////////////////
        //////////////////////////////////////////
        this.buttonSearch.addEventListener('click', function (e) {
            _this.varOffset = 0;
            _this.varPaginationIndex = 0;
            _this.filterFunction();
            $('html,body').animate({
                scrollTop: 0
            }, 'slow');
        });
        //////////////////////////////////////////
        //////////////////////////////////////////
        // button search
        //////////////////////////////////////////
        //////////////////////////////////////////
        if (this.buttonSearchClear) {
            this.buttonSearchClear.addEventListener('click', function (event) {
                var element;
                if (event.currentTarget) {
                    element = event.currentTarget;
                }
                else {
                    element = event.target;
                }
                var parent = element.closest('.filter-builder__form-field--container');
                var clearButton = parent.querySelector('.filter-builder__form-field--searchbuttonclear');
                var searchButton = parent.querySelector('.filter-builder__form-field--searchbutton');
                clearButton.classList.add('d-none');
                searchButton.classList.remove('active');
                _this.filterInput.value = '';
            });
        }
        //////////////////////////////////////////
        //////////////////////////////////////////
        // pagination previous
        //////////////////////////////////////////
        //////////////////////////////////////////
        this.buttonPaginationPrevious.addEventListener('click', function (e) {
            if (!_this.buttonPaginationPrevious.classList.contains('pagination__nav--disabled')) {
                _this.varPaginationIndex = _this.varPaginationIndex - 1;
                var offset = parseInt(_this.varPaginationIndex) * _this.varLimit;
                _this.varOffset = offset;
                _this.filterFunction();
                $('html,body').animate({
                    scrollTop: $('.career-search-component__content').offset().top - 20
                }, 'slow');
            }
        });
        //////////////////////////////////////////
        //////////////////////////////////////////
        // pagination next
        //////////////////////////////////////////
        //////////////////////////////////////////
        this.buttonPaginationNext.addEventListener('click', function (e) {
            if (!_this.buttonPaginationNext.classList.contains('pagination__nav--disabled')) {
                _this.varPaginationIndex = _this.varPaginationIndex + 1;
                var offset = parseInt(_this.varPaginationIndex) * _this.varLimit;
                _this.varOffset = offset;
                _this.filterFunction();
                $('html,body').animate({
                    scrollTop: $('.career-search-component__content').offset().top - 20
                }, 'slow');
            }
        });
    };
    /////////////////////////////////////
    /////////////////////////////////////	
    //// INIT
    /////////////////////////////////////
    /////////////////////////////////////
    CareerSearchComponent.prototype.onload = function () {
        var _this = this;
        this.promiseInitial().then(function (response) {
            // create jobs
            _this.buildLayout(response[0].data, _this.containerShowing, _this.containerLoader, _this.containerItems, _this.containerEmpty, _this.jsShowing, _this.attributeDetailPage);
            // create country options
            _this.locations = response[1].data;
            if (_this.locations.length > 0) {
                var output_1 = "<option value=\"\">All Countries</option>";
                _this.locations.map(function (location) {
                    output_1 += "<option value=\"" + location.code + "\">" + location.name + "</option>";
                });
                _this.filterCountry.innerHTML = output_1;
                _this.filterMobileCountry.innerHTML = output_1;
            }
            // create pagination
            _this.generatePagination(_this.containerPagination, _this.varLimit, response[0].data.totalFound, _this.varPaginationIndex, _this.buttonPaginationPrevious, _this.buttonPaginationNext);
            // analytics
            var analyticsFilter = "country:all country,language:en-gb,arrangement:remote,arrangement:onsite";
            var analyticsTerm = "";
            _this.analyticsSiteSearch(response[0].data.totalFound, analyticsFilter, analyticsTerm);
        });
    };
    /////////////////////////////////////
    /////////////////////////////////////	
    //// PROMISE INITIAL
    /////////////////////////////////////
    /////////////////////////////////////
    CareerSearchComponent.prototype.promiseInitial = function () {
        // let axiosLosers: any = axios.get(urlLosers);
        var postData = '';
        postData = postData + "?limit=" + this.varLimit;
        postData = postData + "&offset=" + this.varOffset;
        postData = postData + "&destination=" + this.varDestination;
        if (this.varLanguage) {
            postData = postData + "&language=" + this.varLanguage;
        }
        postData = postData + "&locationType=" + this.varLocationType;
        postData = postData + "&q=" + this.varQuery;
        if (this.varCountry) {
            postData = postData + "&country=" + this.varCountry;
        }
        if (this.varRegion) {
            postData = postData + "&region=" + this.varRegion;
        }
        if (this.varCity) {
            postData = postData + "&city=" + this.varCity;
        }
        var axiosSmartRecruiter = axios.get(this.varUrl + postData);
        var axiosLocations = axios.get('https://feeds.standardbank.com/Market-Data-Files/careers/locations.json');
        return Promise.all([axiosSmartRecruiter, axiosLocations]);
    };
    /////////////////////////////////////
    /////////////////////////////////////	
    //// PROMISE FILTER CHANGE
    /////////////////////////////////////
    /////////////////////////////////////
    CareerSearchComponent.prototype.promiseFilterChange = function () {
        // let axiosLosers: any = axios.get(urlLosers);
        var postData = '';
        postData = postData + "?limit=" + this.varLimit;
        postData = postData + "&offset=" + this.varOffset;
        postData = postData + "&destination=" + this.varDestination;
        if (this.varLanguage) {
            postData = postData + "&language=" + this.varLanguage;
        }
        postData = postData + "&locationType=" + this.varLocationType;
        postData = postData + "&q=" + this.varQuery;
        if (this.varCountry) {
            postData = postData + "&country=" + this.varCountry;
        }
        if (this.varRegion) {
            postData = postData + "&region=" + this.varRegion;
        }
        if (this.varCity) {
            postData = postData + "&city=" + this.varCity;
        }
        var axiosSmartRecruiter = axios.get(this.varUrl + postData);
        var axiosLocations = axios.get('https://feeds.standardbank.com/Market-Data-Files/careers/locations.json');
        return Promise.all([axiosSmartRecruiter, axiosLocations]);
    };
    /////////////////////////////////////
    /////////////////////////////////////	
    //// FILTER FUNCTION
    /////////////////////////////////////
    /////////////////////////////////////
    CareerSearchComponent.prototype.filterFunction = function () {
        var _this = this;
        this.containerItems.classList.add('d-none');
        this.containerEmpty.classList.add('d-none');
        this.containerPagination.classList.add('d-none');
        this.containerLoader.classList.remove('d-none');
        this.promiseFilterChange().then(function (response) {
            _this.buildLayout(response[0].data, _this.containerShowing, _this.containerLoader, _this.containerItems, _this.containerEmpty, _this.jsShowing, _this.attributeDetailPage);
            _this.generatePagination(_this.containerPagination, _this.varLimit, response[0].data.totalFound, _this.varPaginationIndex, _this.buttonPaginationPrevious, _this.buttonPaginationNext);
            // analytics
            var analyticsFilter = "";
            var analyticsTerm = _this.varQuery;
            if (_this.varCountry) {
                analyticsFilter += "country:" + _this.varCountry;
            }
            if (_this.varRegion) {
                analyticsFilter += ",region:" + _this.varRegion;
            }
            if (_this.varCity) {
                analyticsFilter += ",city:" + _this.varCity;
            }
            if (_this.varLanguage) {
                if (_this.varLanguage === 'pt') {
                    analyticsFilter += ",language:" + _this.varLanguage;
                }
                else {
                    analyticsFilter += ",language:en-GB";
                }
            }
            else {
                analyticsFilter += ",language:en-GB";
            }
            if (_this.varLocationType === 'ANY') {
                analyticsFilter += ",arrangement:ANY";
            }
            else {
                analyticsFilter += ",arrangement:" + _this.varLocationType;
            }
            _this.analyticsSiteSearch(response[0].data.totalFound, analyticsFilter, analyticsTerm);
        });
    };
    /////////////////////////////////////
    /////////////////////////////////////	
    //// BUILD LAYOUT
    /////////////////////////////////////
    /////////////////////////////////////
    CareerSearchComponent.prototype.buildLayout = function (items, containerShowing, containerLoader, containerItems, containerEmpty, jsShowing, detailPageUrl) {
        if (items === void 0) { items = {}; }
        if (containerShowing === void 0) { containerShowing = undefined; }
        if (containerLoader === void 0) { containerLoader = undefined; }
        if (containerItems === void 0) { containerItems = undefined; }
        if (containerEmpty === void 0) { containerEmpty = undefined; }
        if (jsShowing === void 0) { jsShowing = undefined; }
        if (detailPageUrl === void 0) { detailPageUrl = ''; }
        // before completion
        containerItems.innerHTML = "";
        containerItems.classList.add('d-none');
        containerShowing.classList.add('d-none');
        // showing results
        jsShowing.innerHTML = "Showing " + items.totalFound + " available jobs";
        // more than 0 items
        if (items.totalFound > 0) {
            // create items
            var output_2 = "";
            if (items.content.length > 0) {
                var content = items.content;
                content.map(function (item) {
                    // check values
                    var releasedDate = "";
                    var featured = "";
                    var name = "";
                    var location = "";
                    var segment = "";
                    var employmentType = "";
                    var description = "";
                    // checks
                    if (item.releasedDate) {
                        var getTodaysDate = new Date();
                        var getTodaysDay = getTodaysDate.getDate();
                        var systemDate = new Date(item.releasedDate);
                        var systemDay = systemDate.getDate();
                        var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                        var systemDateFormatted = systemDate.getDate() + " " + monthNames[systemDate.getMonth()] + " " + systemDate.getFullYear();
                        var calculate = getTodaysDay - systemDay;
                        var dateFormatted = '';
                        switch (calculate) {
                            case 0:
                                dateFormatted = 'Posted today​';
                                break;
                            case 1:
                                dateFormatted = 'Posted 1 day ago';
                                break;
                            case 2:
                                dateFormatted = 'Posted 2 days ago';
                                break;
                            case 3:
                                dateFormatted = 'Posted 3 days ago';
                                break;
                            case 4:
                                dateFormatted = 'Posted 4 days ago';
                                break;
                            case 5:
                                dateFormatted = 'Posted 5 days ago';
                                break;
                            case 6:
                                dateFormatted = 'Posted 6 days ago';
                                break;
                            case 7:
                                dateFormatted = 'Posted 7 days ago';
                                break;
                            default:
                                dateFormatted = 'Posted ' + systemDateFormatted;
                        }
                        releasedDate = "<span class=\"career-search-component__item--date\">" + dateFormatted + "</span>";
                    }
                    if (item.department) {
                        if (item.department.id) {
                            var customLabel = item.department.label;
                            customLabel = customLabel.replace(' Job', '');
                            customLabel = customLabel.replace(' job', '');
                            customLabel = customLabel.replace(' JOB', '');
                            if (customLabel !== 'Standard') {
                                if (customLabel === 'Non-Perm') {
                                    customLabel = 'Contract';
                                }
                                featured = "<span class=\"feature-badge career-search-component__item--badge\">\n\t\t\t\t\t\t\t\t\t" + customLabel + "\n\t\t\t\t\t\t\t\t</span>";
                            }
                        }
                    }
                    if (item.name) {
                        name = "<span class=\"career-search-component__item--title\">\n\t\t\t\t\t\t\t<h4 class=\"title title--module-sub-title \">\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t" + item.name + "\n\t\t\t\t\t\t\t</h4>\n\t\t\t\t\t\t</span>";
                    }
                    if (item.location) {
                        if (item.location.address) {
                            location += "" + item.location.address;
                        }
                        if (item.location.city) {
                            location += ", " + item.location.city;
                        }
                        if (item.location.region) {
                            location += ", " + item.location.region;
                        }
                        if (item.location.country) {
                            var countryUppercase = item.location.country;
                            location += ", " + countryUppercase.toUpperCase();
                        }
                    }
                    item.customField.map(function (customField) {
                        if (customField.fieldLabel === 'Business Segment') {
                            segment = customField.valueLabel;
                        }
                    });
                    if (item.typeOfEmployment) {
                        employmentType = item.typeOfEmployment.label;
                    }
                    output_2 += "<a href=\"" + detailPageUrl + "?jobID=" + item.id + "\" target=\"_blank\" class=\"career-search-component__item\" data-intent=\"informational\" data-scope=\"all-jobs-listing\" data-id=\"link_content\" data-text=\"" + item.name + " link click\">\n\t\t\t\t\t\t" + releasedDate + "\n\t\t\t\t\t\t" + featured + "\n\t\t\t\t\t\t" + name + "\n\t\t\t\t\t\t<span class=\"career-search-component__item--meta\">\n\t\t\t\t\t\t\t<span class=\"career-search-component__item--meta__segment\">\n\t\t\t\t\t\t\t\t<strong>Location:</strong> " + location + "\t\t\t\t\t\t\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t<span class=\"career-search-component__item--meta__segment\">\n\t\t\t\t\t\t\t\t<strong>Business segment:</strong> " + segment + "\t\t\t\t\t\t\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t<span class=\"career-search-component__item--meta__segment\">\n\t\t\t\t\t\t\t\t<strong>Type of Employment:</strong> " + employmentType + "\t\t\t\t\t\t\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</a>";
                });
                this.containerItems.innerHTML = output_2;
            }
            // after completion
            containerLoader.classList.add('d-none');
            containerItems.classList.remove('d-none');
            containerShowing.classList.remove('d-none');
        }
        else {
            containerLoader.classList.add('d-none');
            containerShowing.classList.remove('d-none');
            containerEmpty.classList.remove('d-none');
        }
    };
    /////////////////////////////////////
    /////////////////////////////////////	
    //// BUILD LAYOUT
    /////////////////////////////////////
    /////////////////////////////////////
    CareerSearchComponent.prototype.buildLocations = function () {
    };
    /////////////////////////////////////
    /////////////////////////////////////	
    //// PAGINATION
    /////////////////////////////////////
    /////////////////////////////////////	
    CareerSearchComponent.prototype.generatePagination = function (container, limit, total, paginationIndex, paginationControlPrev, paginationControlNext) {
        if (container === void 0) { container = ""; }
        if (limit === void 0) { limit = 10; }
        if (total === void 0) { total = 0; }
        if (paginationIndex === void 0) { paginationIndex = 0; }
        if (paginationControlPrev === void 0) { paginationControlPrev = ""; }
        if (paginationControlNext === void 0) { paginationControlNext = ""; }
        if (total > 20) {
            container.classList.remove('d-none');
            var pagination = container.querySelector('.pagination__items');
            var calculate = parseInt(total) / parseInt(limit);
            var times = 0;
            if (calculate.toString().indexOf('.') > -1) {
                var number = parseInt(calculate.toString().split(".")[0]);
                times = number + 1;
            }
            else {
                times = calculate;
            }
            var output = "";
            for (var index = 0; index < times; index++) {
                if (paginationIndex === 0) {
                    paginationControlPrev.classList.add('pagination__nav--disabled');
                    paginationControlNext.classList.remove('pagination__nav--disabled');
                    if (index === 0) {
                        output += "<li class=\"pagination__item pagination__item--active\" data-pagination-index=\"" + index + "\" tabindex=\"" + index + "\" role=\"button\" aria-label=\"Go to slide " + (index + 1) + "\" data-page=\"" + index + "\" data-limit=\"" + limit + "\">" + (index + 1) + "</li>";
                    }
                    else if (index === 1) {
                        output += "<li class=\"pagination__item\" data-pagination-index=\"" + index + "\" tabindex=\"" + index + "\" role=\"button\" aria-label=\"Go to slide " + (index + 1) + "\" data-page=\"" + index + "\" data-limit=\"" + limit + "\">" + (index + 1) + "</li>";
                    }
                    else if (index === 2) {
                        output += "<li class=\"pagination__item\" data-pagination-index=\"" + index + "\" tabindex=\"" + index + "\" role=\"button\" aria-label=\"Go to slide " + (index + 1) + "\" data-page=\"" + index + "\" data-limit=\"" + limit + "\">" + (index + 1) + "</li>";
                    }
                    else {
                        output += "<li class=\"pagination__item d-none\" data-pagination-index=\"" + index + "\" tabindex=\"" + index + "\" role=\"button\" aria-label=\"Go to slide " + (index + 1) + "\" data-page=\"" + index + "\" data-limit=\"" + limit + "\">" + (index + 1) + "</li>";
                    }
                }
                else if (paginationIndex === (times - 1)) {
                    paginationControlPrev.classList.remove('pagination__nav--disabled');
                    paginationControlNext.classList.add('pagination__nav--disabled');
                    if (index === paginationIndex) {
                        output += "<li class=\"pagination__item pagination__item--active\" data-pagination-index=\"" + index + "\" tabindex=\"" + index + "\" role=\"button\" aria-label=\"Go to slide " + (index + 1) + "\" data-page=\"" + index + "\" data-limit=\"" + limit + "\">" + (index + 1) + "</li>";
                    }
                    else if (index === (times - 1)) {
                        output += "<li class=\"pagination__item\" data-pagination-index=\"" + index + "\" tabindex=\"" + index + "\" role=\"button\" aria-label=\"Go to slide " + (index + 1) + "\" data-page=\"" + index + "\" data-limit=\"" + limit + "\">" + (index + 1) + "</li>";
                    }
                    else if (index === (times - 2)) {
                        output += "<li class=\"pagination__item\" data-pagination-index=\"" + index + "\" tabindex=\"" + index + "\" role=\"button\" aria-label=\"Go to slide " + (index + 1) + "\" data-page=\"" + index + "\" data-limit=\"" + limit + "\">" + (index + 1) + "</li>";
                    }
                    else {
                        output += "<li class=\"pagination__item d-none\" data-pagination-index=\"" + index + "\" tabindex=\"" + index + "\" role=\"button\" aria-label=\"Go to slide " + (index + 1) + "\" data-page=\"" + index + "\" data-limit=\"" + limit + "\">" + (index + 1) + "</li>";
                    }
                }
                else {
                    paginationControlPrev.classList.remove('pagination__nav--disabled');
                    paginationControlNext.classList.remove('pagination__nav--disabled');
                    var getPrevious = parseInt(paginationIndex) - 1;
                    var getCurrent = parseInt(paginationIndex);
                    var getNext = parseInt(paginationIndex) + 1;
                    if (index === getPrevious) {
                        output += "<li class=\"pagination__item\" data-pagination-index=\"" + index + "\" tabindex=\"" + index + "\" role=\"button\" aria-label=\"Go to slide " + (index + 1) + "\" data-page=\"" + index + "\" data-limit=\"" + limit + "\">" + (index + 1) + "</li>";
                    }
                    else if (index === getCurrent) {
                        output += "<li class=\"pagination__item pagination__item--active\" data-pagination-index=\"" + index + "\" tabindex=\"" + index + "\" role=\"button\" aria-label=\"Go to slide " + (index + 1) + "\" data-page=\"" + index + "\" data-limit=\"" + limit + "\">" + (index + 1) + "</li>";
                    }
                    else if (index === getNext) {
                        output += "<li class=\"pagination__item\" data-pagination-index=\"" + index + "\" tabindex=\"" + index + "\" role=\"button\" aria-label=\"Go to slide " + (index + 1) + "\" data-page=\"" + index + "\" data-limit=\"" + limit + "\">" + (index + 1) + "</li>";
                    }
                    else {
                        output += "<li class=\"pagination__item d-none\" data-pagination-index=\"" + index + "\" tabindex=\"" + index + "\" role=\"button\" aria-label=\"Go to slide " + (index + 1) + "\" data-page=\"" + index + "\" data-limit=\"" + limit + "\">" + (index + 1) + "</li>";
                    }
                }
            }
            pagination.innerHTML = output;
        }
        else {
            container.classList.add('d-none');
        }
    };
    /////////////////////////////////////
    /////////////////////////////////////	
    //// GENERATE OPTIONS
    /////////////////////////////////////
    /////////////////////////////////////
    CareerSearchComponent.prototype.generateOption = function (container, items, type, key, text, firstSelect) {
        if (container === void 0) { container = undefined; }
        if (items === void 0) { items = []; }
        if (type === void 0) { type = 'normal'; }
        if (key === void 0) { key = ''; }
        if (text === void 0) { text = ''; }
        if (firstSelect === void 0) { firstSelect = ''; }
        var output = "<option value=\"\">" + firstSelect + "</option>";
        items.forEach(function (item) {
            output += "<option value=\"" + item[key] + "\">" + item[text] + "</option>";
        });
        container.innerHTML = output;
    };
    /////////////////////////////////////
    /////////////////////////////////////	
    //// ANALYTICS
    /////////////////////////////////////
    /////////////////////////////////////	
    CareerSearchComponent.prototype.analyticsSiteSearch = function (total, filter, term) {
        if (total === void 0) { total = 0; }
        if (filter === void 0) { filter = ''; }
        if (term === void 0) { term = ''; }
        // analytics
        dataLayer.search.filter = filter;
        dataLayer.numSearchResults = total;
        dataLayer.searchTerm = term;
        _satellite.track('searchButtonSubmit');
    };
    return CareerSearchComponent;
}(Base));
export { CareerSearchComponent };



//////////////////
// WEBPACK FOOTER
// ./components-career/career-search-component/career-search-component.component.ts
// module id = 661
// module chunks = 0